//Get all emailrule for list
const EMAILRULE_TICKET_GET_DATA = {
  EMAILRULE_TICKET_GET_DATA_LOAD: "EMAILRULE_TICKET_GET_DATA_LOAD",
  EMAILRULE_TICKET_GET_DATA_SUCCESS: "EMAILRULE_TICKET_GET_DATA_SUCCESS",
  EMAILRULE_TICKET_GET_DATA_FAIL: "EMAILRULE_TICKET_GET_DATA_FAIL",
};
const EMAILRULE_TICKET_DATA_GET_API = "tickets/email-rules";

//Get emailrule by id
const EMAIL_RULE_GET_DETAILS_DATA = {
  EMAIL_RULE_GET_DETAILS_DATA_LOAD: "EMAIL_RULE_GET_DETAILS_DATA_LOAD",
  EMAIL_RULE_GET_DETAILS_DATA_SUCCESS: "EMAIL_RULE_GET_DETAILS_DATA_SUCCESS",
  EMAIL_RULE_GET_DETAILS_DATA_FAIL: "EMAIL_RULE_GET_DETAILS_DATA_FAIL",
};
const EMAILRULE_GET_DETAIL_API = "tickets/email-rules/";

// Add emailrule
const EMAILRULE_FORM_ADD_DATA = {
  EMAILRULE_FORM_ADD_DATA_LOAD: "EMAILRULE_FORM_ADD_DATA_LOAD",
  EMAILRULE_FORM_ADD_DATA_SUCCESS: "EMAILRULE_FORM_ADD_DATA_SUCCESS",
  EMAILRULE_FORM_ADD_DATA_FAIL: "EMAILRULE_FORM_ADD_DATA_FAIL",
  EMAILRULE_FORM_ADD_DATA_RESET: "EMAILRULE_FORM_ADD_DATA_RESET",
};
const EMAILRULE_FORM_POST_API = "tickets/email-rules";

// Update 
const EMAILRULE_UPDATE_DATA = {
  EMAILRULE_UPDATE_DATA_LOAD: "EMAILRULE_UPDATE_DATA_LOAD",
  EMAILRULE_UPDATE_DATA_SUCCESS: "EMAILRULE_UPDATE_DATA_SUCCESS",
  EMAILRULE_UPDATE_DATA_FAIL: "EMAILRULE_UPDATE_DATA_FAIL",
  EMAILRULE_UPDATE_DATA_RESET: "EMAILRULE_UPDATE_DATA_RESET"
};

const EMAILRULE_POST_API = "tickets/email-rules/";

// Delete emailrule
const EMAILRULE_DELETE_DATA = {
  EMAILRULE_DELETE_LOAD: "EMAILRULE_DELETE_LOAD",
  EMAILRULE_DELETE_SUCCESS: "EMAILRULE_DELETE_SUCCESS",
  EMAILRULE_DELETE_FAIL: "EMAILRULE_DELETE_FAIL",
  EMAILRULE_DELETE_RESET: "EMAILRULE_DELETE_RESET",
};
const EMAILRULE_DELETE_API = "tickets/email-rules/";


export {
  EMAILRULE_TICKET_GET_DATA,
  EMAILRULE_TICKET_DATA_GET_API,
  EMAIL_RULE_GET_DETAILS_DATA,
  EMAILRULE_GET_DETAIL_API,
  EMAILRULE_FORM_ADD_DATA,
  EMAILRULE_FORM_POST_API,
  EMAILRULE_UPDATE_DATA,
  EMAILRULE_POST_API, 
  EMAILRULE_DELETE_DATA,
  EMAILRULE_DELETE_API,  
}